// AP-165 · Français — ERP admin.
const fr = {
  app_name: "JMS ERP",
  loading: "Chargement…",
  save: "Enregistrer",
  cancel: "Annuler",
  edit: "Modifier",
  delete: "Supprimer",
  add: "Ajouter",
  search: "Rechercher",
  actions: "Actions",
  confirm_delete: "Êtes-vous sûr de vouloir supprimer ?",
  yes: "Oui",
  no: "Non",
  optional: "facultatif",
  status: "Statut",
  active: "Actif",
  inactive: "Inactif",
  filter: "Filtrer",
  clear: "Effacer",
  all: "Tous",

  login_title: "Accédez à votre compte",
  login_subtitle: "Gérez clients, services et paiements en toute clarté.",
  email: "E-mail",
  password: "Mot de passe",
  sign_in: "Se connecter",
  signing_in: "Connexion…",
  invalid_credentials: "E-mail ou mot de passe invalide",
  logout: "Déconnexion",

  nav_dashboard: "Tableau de bord",
  nav_customers: "Clients",
  nav_services: "Services",
  nav_payments: "Paiements",
  nav_balance: "Solde",
  nav_documents: "Documents",
  nav_appointments: "Rendez-vous",
  nav_settings: "Paramètres",

  total_customers: "Total Clients",
  total_services: "Total Services",
  total_payments: "Total Paiements",
  outstanding_balance: "Solde dû",
  recent_payments: "Paiements récents",
  no_recent_payments: "Aucun paiement récent.",
  amount: "Montant",
  method: "Méthode",
  date: "Date",

  customers_title: "Clients",
  customers_subtitle: "Gérez vos clients et leurs coordonnées.",
  full_name: "Nom complet",
  phone: "Téléphone",
  whatsapp: "WhatsApp",
  address: "Adresse",
  notes: "Notes",
  add_customer: "Nouveau client",
  edit_customer: "Modifier le client",
  no_customers: "Aucun client enregistré.",

  services_title: "Services",
  services_subtitle: "Enregistrez les services proposés par votre entreprise.",
  service_name: "Nom du service",
  description: "Description",
  price: "Prix",
  add_service: "Nouveau service",
  edit_service: "Modifier le service",
  no_services: "Aucun service enregistré.",

  payments_title: "Paiements",
  payments_subtitle: "Enregistrez les paiements et suivez le solde restant.",
  customer: "Client",
  service: "Service",
  service_price: "Prix du service",
  amount_paid: "Montant payé",
  payment_date: "Date du paiement",
  payment_method: "Mode de paiement",
  remaining_balance: "Solde restant",
  add_payment: "Nouveau paiement",
  edit_payment: "Modifier le paiement",
  no_payments: "Aucun paiement enregistré.",
  method_cash: "Espèces",
  method_pix: "PIX",
  method_bank: "Virement",
  method_card: "Carte",
  select_customer: "Sélectionnez un client",
  select_service: "Sélectionnez un service",
  select_method: "Sélectionnez un mode",

  balance_title: "Solde",
  balance_subtitle: "Vue consolidée des paiements et soldes par client et service.",
  total_price: "Prix total",
  total_paid: "Total payé",
  only_pending: "Uniquement en attente",
  no_balance: "Aucun solde à afficher.",

  settings_title: "Paramètres",
  settings_subtitle: "Préférences de l'entreprise et de l'utilisateur.",
  company_settings: "Entreprise",
  company_name: "Nom de l'entreprise",
  company_logo: "URL du logo",
  currency: "Devise",
  language: "Langue",
  user_profile: "Profil de l'utilisateur",
  name: "Nom",
  current_password: "Mot de passe actuel",
  new_password: "Nouveau mot de passe",
  update_profile: "Mettre à jour le profil",
  update_company: "Mettre à jour l'entreprise",
  saved_successfully: "Enregistré avec succès",

  created: "Créé avec succès",
  updated: "Mis à jour avec succès",
  deleted: "Supprimé avec succès",
  error_generic: "Une erreur est survenue. Réessayez.",

  // AP-165 Fase 2 · Services
  svc_pricing_type: "Type de facturation",
  svc_per_service: "Facturé au service",
  svc_per_unit: "Facturé à l'unité",
  svc_per_time: "Facturé au temps",
  svc_hint_per_unit: "Le client achète plusieurs unités (ex. : photocopie, photo 3x4).",
  svc_hint_per_time: "Facturé par durée (ex. : consultation à l'heure).",
  svc_hint_per_service: "Prix forfaitaire par service.",
  svc_unit_label: "Unité de mesure",
  svc_unit_ph_time: "Heure",
  svc_unit_ph_unit: "Page, Copie, Photo…",
  svc_price_per_unit: "Prix par unité",
  svc_price_per_hour: "Prix par heure",

  // AP-165 Fase 2 · Customers
  cus_view: "Voir :",
  cus_visible: "Visibles",
  cus_hidden: "Masqués",
  cus_contact: "Contact",
  cus_hidden_badge: "Client masqué",
  cus_open: "Ouvrir",
  cus_show: "Afficher le client",
  cus_hide: "Masquer le client",
  cus_delete_title: "Supprimer le client",
  cus_delete_desc_1: "Le client {name} sera retiré de la liste principale, mais toutes ses données resteront enregistrées dans le système.",
  cus_delete_desc_2: "Le Master pourra le restaurer plus tard depuis la Corbeille.",
  cus_delete_confirm_q: "Voulez-vous continuer ?",
  cus_attention: "ATTENTION",
  cus_show_title: "Afficher le client",
  cus_show_desc: "Souhaitez-vous restaurer le client {name} à la vue de tous les utilisateurs autorisés ?",
  cus_hide_desc: "Voulez-vous masquer le client {name} ? Toutes les données resteront enregistrées. Le client cessera simplement d'apparaître aux utilisateurs ordinaires.",
  cus_hide_reason_label: "Motif (optionnel)",
  cus_hide_reason_ph: "Ex. : Client archivé, revue interne…",
  cus_btn_show: "Afficher",
  cus_btn_hide: "Masquer",

  // AP-165 Fase 2 · Payments
  pay_combobox_placeholder: "Chercher par nom, CPF, WhatsApp, e-mail ou dossier…",
  pay_combobox_search_ph: "Tapez pour chercher…",
  pay_combobox_searching: "Recherche…",
  pay_combobox_empty: "Aucun client trouvé.",
  pay_discount_promocao_jms: "Promo JMS",
  pay_discount_desconto_comercial: "Remise commerciale",
  pay_discount_cliente_fidelizado: "Client fidèle",
  pay_discount_ajuste_preco: "Ajustement de prix",
  pay_discount_campanha_especial: "Campagne spéciale",
  pay_discount_outro: "Autre",
};
export default fr;
